import {
  KB_ARTICLE_STATUS_LABELS,
  KB_VISIBILITY_LABELS,
  type KbArticleStatus,
  type KbVisibility,
} from '@gb-ticket/shared-types';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export function KbStatusBadge({ status }: { status: KbArticleStatus }) {
  return (
    <Badge
      variant="outline"
      className={cn(
        status === 'DRAFT' && 'border-zinc-300 text-zinc-700',
        status === 'IN_REVIEW' && 'border-amber-300 bg-amber-50 text-amber-900',
        status === 'PUBLISHED' && 'border-emerald-300 bg-emerald-50 text-emerald-800',
        status === 'ARCHIVED' && 'border-zinc-400 bg-zinc-100 text-zinc-600',
      )}
    >
      {KB_ARTICLE_STATUS_LABELS[status]}
    </Badge>
  );
}

export function KbVisibilityBadge({ visibility }: { visibility: KbVisibility }) {
  return (
    <Badge variant={visibility === 'PUBLIC' ? 'secondary' : 'outline'}>
      {KB_VISIBILITY_LABELS[visibility]}
    </Badge>
  );
}
